import { render } from "./CICOPage.vue?vue&type=template&id=6899f45c&scoped=true"
import script from "./CICOPage.vue?vue&type=script&lang=js"
export * from "./CICOPage.vue?vue&type=script&lang=js"

import "./CICOPage.vue?vue&type=style&index=0&id=6899f45c&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6899f45c"]])

export default __exports__